<template>
    <div>
        <p class="card-text">
            <LinkLabel
                class="card-label d-inline-block text-truncate mw-300-px mw-lg-450-px mw-xl-700-px"
                show-url
                :link="link" />
        </p>

        <p class="card-text small text-muted mb-0">
            <CreatedAtLabel class="card-label" :date="link.created_at" />
            <DeletedAtLabel v-if="link.deleted_at" class="card-label" :date="link.deleted_at" />
        </p>
    </div>
</template>

<script>
import CreatedAtLabel from '@/js/components/common/labels/CreatedAtLabel';
import DeletedAtLabel from '@/js/components/common/labels/DeletedAtLabel';
import LinkLabel from '@/js/components/link/LinkLabel';

export default {
    name: 'LinkContent',

    components: {CreatedAtLabel, DeletedAtLabel, LinkLabel},

    props: {
        link: {type: Object, required: true},
    },
};
</script>
